import { Link} from "react-router-dom";
import { memo } from "react";
import { useShopbyDesign } from "../hooks/useShopbyDesign";
import { getListingUrl } from "../../../utils/url.utils";

function ShopbyDesign() {
  const { carpets, loading } = useShopbyDesign();
  if (loading) return null;
  // Agar API no data hide section
  if (!carpets || carpets.length === 0) {
    return null;
  }

  return (
    <section>
      <div className="carpet-section">
        <h2 className="carpet-heading"> Shop by Design </h2>
        <div className="carpet-grid">
          {carpets.slice(0, 6).map((item) => (
            <Link key={item.id} to={item.link} target="_blank">
              <div className="carpet-tile">
                <img src={item.image} alt={item.title} loading="lazy" />
                <div className="carpet-label">{item.title}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
export default memo(ShopbyDesign);